/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import { useOutletContext, Outlet } from "react-router-dom";
// BASE components
import BASESvgIcon from "../../../../../@BASE/core/BASESvgIcon";
// Material UI
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

export default function Version(props) {
  const { resource, instance } = useOutletContext();

  return (
    <div className="relative flex flex-col flex-auto mt-64 px-24 sm:px-48">
      <Typography className="mt-12 text-2xl font-bold truncate">
        Versions
      </Typography>
      <Divider className="mt-16 mb-24" />
      <Outlet context={{resource, instance}} />
    </div>
  );
}